(function () {
  function formatCartMoney(cents, currency) {
    var cur = currency || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: 'currency',
        currency: cur,
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + ' ' + cur;
    }
  }

  window.themeRefreshCartCount = function themeRefreshCartCount() {
    return fetch('/cart.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble) {
          var countWrap = bubble.querySelector('.cart-count-bubble');
          if (cart.item_count > 0) {
            if (!countWrap) {
              countWrap = document.createElement('div');
              countWrap.className = 'cart-count-bubble';
              bubble.appendChild(countWrap);
            }
            var num = countWrap.querySelector('span[aria-hidden="true"]');
            if (cart.item_count < 100) {
              if (!num) {
                num = document.createElement('span');
                num.setAttribute('aria-hidden', 'true');
                countWrap.insertBefore(num, countWrap.firstChild);
              }
              num.textContent = String(cart.item_count);
            } else if (num) {
              num.remove();
            }
          } else if (countWrap) {
            countWrap.remove();
          }
        }

        document.querySelectorAll('.cart-count').forEach(function (el) {
          el.textContent = String(cart.item_count);
        });

        var formatted = formatCartMoney(cart.total_price, cart.currency);
        document.querySelectorAll('.cart-subtotal').forEach(function (el) {
          el.textContent = formatted;
        });
      })
      .catch(function () {});
  };

  window.themeAfterLineItemAdd = function themeAfterLineItemAdd() {
    if (window.Rebuy && window.Rebuy.SmartCart) {
      try {
        window.Rebuy.SmartCart.show();
      } catch (e) {}
    }
    window.themeRefreshCartCount();
  };

  function bindHeaderCartIconToRebuy() {
    document.addEventListener(
      'click',
      function (e) {
        var link = e.target.closest('#cart-icon-bubble');
        if (!link || !window.Rebuy || !window.Rebuy.SmartCart) return;
        if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        e.preventDefault();
        try {
          window.Rebuy.SmartCart.show();
        } catch (err) {}
      },
      true
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindHeaderCartIconToRebuy);
  } else {
    bindHeaderCartIconToRebuy();
  }
})();
